// import io from "socket.io-client";
import { SOCKET_URL } from "../environment";
import { w3cwebsocket as W3CWebSocket } from "websocket";

import React from "react";
// export const socket = new WebSocket(SOCKET_URL);
export const client = new W3CWebSocket(SOCKET_URL);
export const SocketContext = React.createContext();
